export interface MockFaq {
  q: string;
  a: string;
}

export const mockFaqs: MockFaq[] = [
  {
    q: '网报吃瓜主要收录什么样的内容？',
    a: '我们聚焦正在被广泛讨论的网络热点，把网友评论、热议角度、讨论走向和不同立场整理在一起。你看到的不是单条新闻，而是一群人怎么想、为什么这么想。',
  },
  {
    q: '热度值和参与人数是怎么来的？',
    a: '热度值综合了话题在多个公开讨论场景下的传播速度、讨论增量与互动密度，参与人数则是近期实际留下观点的人数统计。它们反映的是讨论规模，不代表对事件本身的判断。',
  },
  {
    q: '立场分布里的支持、反对、观望分别指什么？',
    a: '这是对评论区主要观点的归纳。支持指倾向认可某一方的做法或结论，反对指持保留或相反意见，观望指暂不下结论、希望看到更多信息。三者相加为一百，方便你一眼看清主流情绪。',
  },
  {
    q: '为什么同一个话题会出现截然不同的看法？',
    a: '大多数热点本身就涉及立场、经历与信息差。我们把不同声音并列展示，是为了让你在形成判断前，先看到讨论的全貌，而不是被单一情绪带着走。',
  },
  {
    q: '遇到我不了解来龙去脉的话题怎么办？',
    a: '每个话题详情页都提供事件概述、关键时间线和主要争议点。建议先读概述，再从评论流里挑几条高赞观点，基本就能跟上讨论节奏。',
  },
  {
    q: '我可以提交自己关注的热点吗？',
    a: '可以。通过首页底部的热点周报订阅入口留下联系方式，或在关于我们页面用邮箱联系我们，我们会把大家反复提到的选题纳入观察清单。',
  },
];